import "@/App.css";
import { Hero, About, Market } from "@/components/als/Intro";
import { Services } from "@/components/als/Services";
import { TrackRecord, Clients, Sectors } from "@/components/als/TrackRecord";
import { Team } from "@/components/als/Team";
import { WhyAls, Audiences } from "@/components/als/WhyAls";
import { Contact } from "@/components/als/Contact";
import { Header } from "@/components/als/Header";
import { Footer } from "@/components/als/Footer";

function App() {
  return (
    <div id="top" className="min-h-screen bg-white text-[#111111]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <TrackRecord />
        <About />
        <Market />
        <Services />
        <Clients />
        <Sectors />
        <Team />
        <WhyAls />
        <Audiences />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
